import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Container, Row, Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import messages from '../../locale/messages';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { formValueSelector } from 'redux-form';
import Link from '../../components/Link';
import FooterSkeleton from '../Skeleton/ViewBooking/FooterSkeleton/FooterSkeleton';
import { getDynamicTitleByLocale, getDynamicTitleByName } from '../../helpers/getDynamicTitle';
import getAllHomePageSettingsQuery from './getAllHomePageSettings.graphql';
import getContentPageDetailsQuery from './getContentPage.graphql';
import { FooterListStyleIcon } from '../Common/Assets/SVGIcon/CommonSvgIcon';
/* Images */
import Visa from '/public/Icons/visa.svg';
import MasterCard from '/public/Icons/masterCard.svg';
import AmericanExpress from '/public/Icons/american-express.svg';
import Discover from '/public/Icons/discover.svg';
import FaceBookIcon from '/public/Icons/faceBookIcon.svg';
import InstagramIcon from '/public/Icons/instagramIcon.svg';
import TwitterIcon from '/public/Icons/twitterIcon.svg';
import YouTubeIcon from '/public/Icons/youtubeIcon.svg';
import s from './Footer.css';


function Footer({ isBottomBanner }) {
  const { data: homePageData, loading } = useQuery(getAllHomePageSettingsQuery, {
    ssr: true,
    fetchPolicy: 'network-only',
  });

  const { data: contentPageData } = useQuery(getContentPageDetailsQuery, {
    fetchPolicy: 'network-only',
    ssr: false
  });

  const youtubeLink = useSelector((state) => state?.siteSettings?.data?.youtubeLink);
  const twitterLink = useSelector((state) => state?.siteSettings?.data?.twitterLink);
  const facebookLink = useSelector((state) => state?.siteSettings?.data?.facebookLink);
  const instagramLink = useSelector((state) => state?.siteSettings?.data?.instagramLink);
  const currentLocale = useSelector((state) => state?.intl?.locale);
  const bookingStatus = useSelector((state) => state?.bookingDetails?.data?.status);
  const ordersData = useSelector((state) => formValueSelector('BookingForm')(state, 'orderData'));

  let homeSettings = {};
  let dynamicHomePageSettings = [];

  if (!loading && homePageData?.getAllHomePageSettings?.homePageData) {
    homePageData.getAllHomePageSettings.homePageData.forEach((item) => {
      if (Array.isArray(item?.dynamicHomePageSettings)) {
        item.dynamicHomePageSettings.forEach((o) => {
          const newItem = Object.assign({}, o, { name: item?.name });
          dynamicHomePageSettings.push(newItem);
        });
      }
      homeSettings[item.name] = item.value;
    });
  }

  const checkUrl = contentPageData?.getContentPageDetails?.results?.some((item) => item.isEnable) ? 1 : 0;

  const footerSection = getDynamicTitleByName({ dynamicHomePageSettings, name: 'footerTitle1' });
  let footerSectionData = getDynamicTitleByLocale({ dynamicHomePageSettings: footerSection, locale: currentLocale });
  footerSectionData = footerSectionData?.length > 0 ? footerSectionData[0] : footerSection?.[0];

  if (loading) {
    return <FooterSkeleton />
  }
  return (
    <>
      {!loading && homePageData?.getAllHomePageSettings?.homePageData && (
        <footer className={cx(s.footerBox, { [s.isFooterBottomSpace]: (isBottomBanner || bookingStatus === 'completed' || ordersData?.length > 0) })}>
          <Container>
            <Row className={s.footerRowList}>
              <Col xl={!(checkUrl === 1) ? 6 : 4} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <h3 className={s.footerListHeading}>{footerSectionData?.value}</h3>
                  <p className={s.footerContent}>{footerSectionData?.description}</p>
                </div>
              </Col>
              {checkUrl === 1 && (
                <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                  <div>
                    <h3 className={s.footerListHeading}>{footerSectionData?.urlTitle}</h3>
                    <ul className={s.usefulLinkListContainer}>
                      <li><Link to={'/terms-of-service'} className={cx(s.footerContent, s.usefulLink, 'usefulLinkRtl')}><FormattedMessage {...messages.termsOfService} /></Link></li>
                      {contentPageData?.getContentPageDetails?.results?.map(
                        (item, index) =>
                          item.isEnable && (
                            <li key={index}>
                              <Link to={`/${item.pageUrl}`} className={cx(s.footerContent, s.usefulLink, 'usefulLinkRtl')}>
                                <FooterListStyleIcon />
                                <span>{item.pageTitle}</span>
                              </Link>
                            </li>
                          )
                      )}
                    </ul>
                  </div>
                </Col>
              )}
              <Col xl={!(checkUrl === 1) ? 3 : 2} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <h3 className={s.footerListHeading}><FormattedMessage {...messages.followUs} /></h3>
                  <ul className={cx(s.footerListContainer, s.socialListContainerGap)}>
                    {facebookLink && (
                      <li>
                        <a href={facebookLink} target="_blank" rel="noopener noreferrer" aria-label={"facebook"}>
                          <img src={FaceBookIcon} alt="Facebook" />
                        </a>
                      </li>
                    )}
                    {instagramLink && (
                      <li>
                        <a href={instagramLink} target="_blank" rel="noopener noreferrer" aria-label={"instagram"}>
                          <img src={InstagramIcon} alt="Instagram" />
                        </a>
                      </li>
                    )}
                    {twitterLink && (
                      <li>
                        <a href={twitterLink} target="_blank" rel="noopener noreferrer" aria-label={"twitter"}>
                          <img src={TwitterIcon} alt="Twitter" />
                        </a>
                      </li>
                    )}
                    {youtubeLink && (
                      <li>
                        <a href={youtubeLink} target="_blank" rel="noopener noreferrer" aria-label={"youtube"}>
                          <img src={YouTubeIcon} alt="YouTube" />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </Col>
              <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <h3 className={s.footerListHeading}><FormattedMessage {...messages.SupportedPayments} /></h3>
                  <ul className={cx(s.footerListContainer, s.paymentListContainerGap)}>
                    <li>
                      <img src={Visa} alt="visa" className={s.paymentCardIcon} />
                    </li>
                    <li>
                      <img src={MasterCard} alt="masterCard" className={s.paymentCardIcon} />
                    </li>
                    <li>
                      <img src={AmericanExpress} alt="americanExpress" className={s.paymentCardIcon} />
                    </li>
                    <li>
                      <img src={Discover} alt="discover" className={s.paymentCardIcon} />
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
            <div className={s.copyRightContainer}>{homeSettings?.footerBottom}</div>
          </Container>
        </footer>
      )}
    </>
  );
}

export default withStyles(s)(Footer);
